module.exports = __webpack_public_path__ + "media/pxels.45bace9c.mp4";